import {initializeAlpine} from "./alpine"
import {createLightbox} from "./photoswiper";
import initializeSwipers from "./swipers";

initializeAlpine();
initializeSwipers();

let lightboxes = document.querySelectorAll(".js-lightbox")
lightboxes.forEach(lightbox => {
    createLightbox(lightbox)
})
